import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import {AuthService} from "../../shared/services/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // skip auth endpoints if needed
  if (req.url.includes('/login') || req.url.includes('/register')) return next(req);

  const auth = inject(AuthService);
  const token = auth.getToken();

  console.log('token', token)
  if (!token) return next(req);

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
